<template>
  <div class="dashboard-card">
    <div class="card-header">Top posities</div>
    <FundDetailScreen ref="fundDetails"/>
    <template
      v-if="topPositions.length > 0"
    >
      <table class="new click-tr">
        <tr
          v-for="pos in topPositions"
          :key="pos.id"
          @click="openFundDetailScreen(pos.id)"
        >
          <td>{{pos.name}}</td>
          <td class="number">&euro;{{'\xa0'}}{{formatPrice(pos.worth, true)}}</td>
          <td class="number green">
            +{{'\xa0'}}{{formatPrice(pos.result, true)}}
          </td>
          <td class="number">
            +{{'\xa0'}}{{formatPrice(pos.result * 100 / pos.purchaseCost, true)}}%
          </td>
        </tr>
      </table>
      <div class="card-bottom">
        <a class="button secondary" @click="$parent.clickDetails('new_class')">
          Alle posities <awesomeIcon icon="chart-line"/>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import {
  reverse,
  takeRight,
  findIndex,
  sortBy,
} from 'lodash-es';

import FundDetailScreen from '../FundDetailScreen';

export default {
  name: 'TopAssetsWidget',
  components: {
    FundDetailScreen,
  },
  computed: {
    topPositions() {
      return reverse(
        takeRight(
          sortBy(
            this.positions.filter((x) => x.result.toFixed(0) > 0 && x.original_class !== 'Coupons'),
            'result',
          ),
          5,
        ),
      );
    },
    positions() {
      return this.$parent.positions;
    },
  },
  methods: {
    openFundDetailScreen(id) {
      this.$refs.fundDetails.assetId = findIndex(this.positions, (o) => o.id === id);
    },
  },
};
</script>

<style lang="scss" scoped>
  @media #{$mobile} {
    tr td:nth-child(4n+4), tr th:nth-child(4n+4) {
      display: none;
    }
  }
  table.new {
    margin: 0 15px;
    width: calc(100% - 30px);
  }
</style>
